import React from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarLayout } from '../catalyst/sidebar-layout';
import { Navbar, NavbarSection, NavbarSpacer } from '../catalyst/navbar';
import {
	Sidebar,
	SidebarHeader,
	SidebarSection,
	SidebarItem,
	SidebarBody,
	SidebarFooter
} from '../catalyst/sidebar';
import { Button } from '../catalyst/button';
import { Home, Package, Tag, Users, MessageSquare, LogOut, BookOpen, Activity } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ApplicationLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const location = useLocation();
	const { signOut, user } = useAuth();

	return (
		<SidebarLayout
			navbar={
				<Navbar>
					<NavbarSection>
						<img src="/melonpost_logo_light.webp" alt="Melonpost" className="h-8 w-auto object-contain shrink-0" />
					</NavbarSection>
					<NavbarSpacer />
				</Navbar>
			}
			sidebar={
				<Sidebar>
					<SidebarHeader>
						<img src="/melonpost_logo_light.webp" alt="Melonpost" className="h-10 w-auto object-contain" />
					</SidebarHeader>

					<SidebarBody>
						<SidebarSection>
							<SidebarItem
								href="/"
								current={location.pathname === '/'}
							>
								<Home className="w-4 h-4" />
								Dashboard
							</SidebarItem>
							<SidebarItem
								href="/orders"
								current={location.pathname.startsWith('/orders')}
							>
								<Package className="w-4 h-4" />
								Orders
							</SidebarItem>
							<SidebarItem
								href="/codes"
								current={location.pathname.startsWith('/codes')}
							>
								<Tag className="w-4 h-4" />
								Codes
							</SidebarItem>
							<SidebarItem
								href="/ledger"
								current={location.pathname.startsWith('/ledger')}
							>
								<BookOpen className="w-4 h-4" />
								Ledger
							</SidebarItem>
							<SidebarItem
								href="/users"
								current={location.pathname.startsWith('/users')}
							>
								<Users className="w-4 h-4" />
								Users
							</SidebarItem>
							<SidebarItem
								href="/chats"
								current={location.pathname.startsWith('/chats')}
							>
								<MessageSquare className="w-4 h-4" />
								Chats
							</SidebarItem>
							<SidebarItem
								href="/status"
								current={location.pathname.startsWith('/status')}
							>
								<Activity className="w-4 h-4" />
								Status
							</SidebarItem>
						</SidebarSection>
					</SidebarBody>

					<SidebarFooter>
						<div className="space-y-2">
							{user && (
								<div className="text-xs text-white/60 truncate">
									{user.email}
								</div>
							)}
							<Button plain onClick={signOut} className="w-full justify-start gap-2 text-sm text-white/80 hover:text-white">
								<LogOut className="w-4 h-4" />
								Sign out
							</Button>
						</div>
					</SidebarFooter>
				</Sidebar>
			}
		>
			<div className="flex flex-1 flex-col overflow-hidden">
				{children}
			</div>
		</SidebarLayout>
	);
};

export default ApplicationLayout;
